// dataSimulator.js

const simulateData = (updateDataCallback) => {
    const getRandomValue = (min, max) => Math.random() * (max - min) + min;
  
    let counter = 0;
    const systems = ['BMS', 'BPS', 'PDB', 'MPPT1', 'MPPT2', 'MC1', 'MC2'];
  
    setInterval(() => {
      const data = {
        BMS: {},
        BPS: {},
        PDB: {},
        MPPT1: {},
        MPPT2: {},
        MC1: {},
        MC2: {},
        faults: []
      };
  
      const system = systems[counter % systems.length];
      counter++;
  
      switch (system) {
        case 'BMS':
          data.BMS = {
            pack_voltage: getRandomValue(300, 400),
            pack_current: getRandomValue(50, 100),
            pack_soc: getRandomValue(20, 80),
            high_cell_voltage: getRandomValue(4, 4.2),
            low_cell_voltage: getRandomValue(3.5, 4),
            average_cell_voltage: getRandomValue(3.7, 4.1),
          };
          break;
        case 'BPS':
          data.BPS = {
            therm_fault: Math.random() > 0.9,
            pdb_fault: Math.random() > 0.9 ? "fault" : "no fault",
            supp_fault: Math.random() > 0.9 ? "fault" : "no fault",
            can_fault: Math.random() > 0.9,
            therm_temp: getRandomValue(10, 100),
            pdb_voltage: getRandomValue(10, 14),
            supp_voltage: getRandomValue(10, 14),
            supp_current: getRandomValue(0, 5),
          };
          break;
        case 'PDB':
          data.PDB = {
            voltage: getRandomValue(10, 14),
            current: getRandomValue(0, 5),
            power_fault: Math.random() > 0.9,
          };
          break;
        case 'MPPT1':
          data.MPPT1 = {
            input_voltage: getRandomValue(100, 200),
            input_current: getRandomValue(5, 10),
            output_voltage: getRandomValue(200, 400),
            output_current: getRandomValue(10, 20),
            mode: "normal",
            faults: [],
            enabled: Math.random() > 0.5,
            amb_temp: getRandomValue(1, 3),
            heatsnk_temp: getRandomValue(10, 100),
          };
          break;
        case 'MPPT2':
          data.MPPT2 = {
            input_voltage: getRandomValue(100, 200),
            input_current: getRandomValue(5, 10),
            output_voltage: getRandomValue(200, 400),
            output_current: getRandomValue(0, 2),
            mode: "normal",
            faults: [],
            enabled: Math.random() > 0.5,
            amb_temp: getRandomValue(10, 100),
            heatsnk_temp: getRandomValue(20, 60),
          };
          break;
        case 'MC1':
          data.MC1 = {
            speed: getRandomValue(0, 100),
            current: getRandomValue(0, 50),
            battery_voltage: getRandomValue(300, 400),
            error_codes: [],
            throttle_signal: getRandomValue(0, 100),
            controller_temp: getRandomValue(20, 60),
            motor_temp: getRandomValue(10, 100),
            status: {
              feedback_status: "ok",
              command_status: "ok",
            },
            switch_signals: {
              boost_switch: Math.random() > 0.5,
              foot_switch: Math.random() > 0.5,
              forward_switch: Math.random() > 0.5,
              backward_switch: Math.random() > 0.5,
              brake_switch: Math.random() > 0.5,
              hall_c: Math.random() > 0.5,
              hall_b: Math.random() > 0.5,
              hall_a: Math.random() > 0.5,
            }
          };
          break;
        case 'MC2':
          data.MC2 = {
            speed: getRandomValue(0, 100),
            current: getRandomValue(0, 50),
            battery_voltage: getRandomValue(300, 400),
            error_codes: [],
            throttle_signal: getRandomValue(0, 100),
            controller_temp: getRandomValue(20, 60),
            motor_temp: getRandomValue(10, 100),
            status: {
              feedback_status: "ok",
              command_status: "ok",
            },
            switch_signals: {
              boost_switch: Math.random() > 0.5,
              foot_switch: Math.random() > 0.5,
              forward_switch: Math.random() > 0.5,
              backward_switch: Math.random() > 0.5,
              brake_switch: Math.random() > 0.5,
              hall_c: Math.random() > 0.5,
              hall_b: Math.random() > 0.5,
              hall_a: Math.random() > 0.5,
            }
          };
          break;
        default:
          break;
      }
  
      // Add fault data
      data.faults.push({
        timestamp: new Date().toISOString(),
        code: "001",
        description: "Sample fault description"
      });
  
      updateDataCallback(data);
    }, 1000);
  };
  
  export default simulateData;
  